import { defineMessages } from 'react-intl';

export const ADDRESS_COOKIE_KEY = 'address_cookie';

export const THROTTLE_CHANGE = 200;
export const THROTTLE_RESIZE = 500;
export const GOOGLE_MAPS_API_TIMEOUT = 1000;
export const TEXT_LENGTH_THRESHOLD = 3;

export const DEFAULT_LAT = 40.7242802;
export const DEFAULT_LNG = -73.9995428;
export const BIAS_RADIUS = 16093; // 10 miles in meters

export const LOCALIZED_STRINGS = defineMessages({
    Loading: {
        id: 'LocationAutoComplete.Loading',
        defaultMessage: 'loading...',
    },
    MyCurrentLocation: {
        id: 'LocationAutoComplete.UseCurrentLocation',
        defaultMessage: 'my current location',
    },
    Placeholder: {
        id: 'LocationAutoComplete.Placeholder',
        defaultMessage: 'zip code or city',
    },
});
